import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { LogService } from '../log.service';
import { AccountService } from '../account.service';
import { BackendService, Message } from '../backend.service';

export class Tournament {
  ID: number;
  Name: string;
}

@Injectable({
  providedIn: 'root'
})
export class TournamentsService {
  private tournaments: Tournament[];
  private backendResponse: Message;

  constructor(private backend: BackendService,
    private log: LogService,
    private account: AccountService) {}

  private ParseTournamentsFromResponse(tournamentsNotification$: Subject<Tournament[]>) {
    this.tournaments = [];

    if (this.backendResponse.Code === 200) {
      this.backendResponse.Payload.forEach(element => {
        this.tournaments.push({
          ID: element[0],
          Name: element[1]
        });
      });
    }
    tournamentsNotification$.next(this.tournaments);
  }

  public GetAll(): Observable<Tournament[]> {
    const tournamentsNotification$ = new Subject<Tournament[]>();
    const account = this.account.GetAccountData();
    const request = JSON.stringify({
      operation: 'GET',
      resource: 'BowHunter/Tournaments',
      username: account.username,
      password: account.password
    });

    this.backend.sendRequest(request).subscribe(
      (msg: Message) => {
        this.backendResponse = msg;
        this.ParseTournamentsFromResponse(tournamentsNotification$);
      },
      error => {
        this.log.LogError(error);
      }
    );

    return tournamentsNotification$;
  }
}
